<script setup lang="ts">
/**
 * The detail view of a file is a larger icon view with the name and path stacked
 * beside it
 */
import { PropertyColor, PropertySize } from "~/classes/generated/interface"

const props = defineProps({
  file: null,
  hideThumbnail: { type: Boolean },
  selectable: { type: Boolean },
  background: { type: Boolean },
  hovered: { type: Boolean }
})

const { selectFile, isSelectedIn } = useSelection()
const { navigateToFile } = useNavigation()

const selected = computed(() => isSelectedIn(props.file.id, "agent"))
const selectedHere = ref(false)

const onClickedFile = () => {
  if (!props.selectable)
    return
  if (selectedHere.value) {
    navigateToFile(props.file)
    selectedHere.value = false
  }
  else {
    selectFile(props.file, "agent")
    selectedHere.value = true
  }
}
watch(selected, (isSelected) => {
  if (!props.selectable)
    return
  if (!isSelected)
    selectedHere.value = false
})
</script>

<template>
  <div
    class="item"
    :class="{ hovered, selected, selectedHere, selectable }"
    @click="onClickedFile()"
  >
    <file-thumbnail
      v-if="!hideThumbnail"
      class="file-thumbnail"
      :file
      :container-height="24"
      :container-width="24"
      cropped
    />
    <div class="info">
      <div class="name">
        {{ file.name() }}
      </div>
      <div class="path">
        <file-property-path
          :file
          :size="PropertySize.Small"
          :color="PropertyColor.Steel"
        />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.item
  @apply flex-none -m-0.75 p-0.75 rounded-[#{$menu-br-item}]
  @apply flex items-center gap-[#{$page-file-gap-detail}]
  @apply cursor-pointer
  &.selectable
    @apply cursor-pointer
    &:hover, &.hovered
      @apply bg-[#{$panel-agent-bg-file-hover}]
    &.background:not(:hover):not(.selectedHere)
      @apply bg-[#{$panel-agent-bg-file-inline-bubble}]
    &.selectedHere
      @apply bg-$global-blue-primary
      .path
        @apply text-[#{$global-t-default}]

.file-thumbnail
  @apply h-full aspect-square
.info
  @apply w-full min-w-0
.name
  @apply text-ellipses-inline t-sidebar-item
.path
  @apply h-[14px] t-property-sm text-[#{$global-t-quaternary}] flex items-center
</style>
